import React, {Component} from "react";
import {connect} from "react-redux";
import CarouselItem from "./../../../blocks/CarouselItem";
import Source from "./../../../items/Source";
import SVGImage from "./../../../svg/SVGImage";


class GeoConcentrationToday extends Component {

  render() {

    const {baseUrl} = this.props;

    return (
      <CarouselItem title="Increasing geographic concentration">
        <div className="fow-col fow-col-1-2 fow-md-col-1">
          <p className="fow-font-text fow-font-size-md">In our midpoint automation adoption scenario, technology begins to handle work activities equivalent to 53 million jobs by 2030. But Europe could add many new jobs in the next decade. At the same time, the working-age population will likely shrink by 13.5 million (or 4 percent) due to aging.</p>
          <p className="fow-font-text fow-font-size-md">Growth will likely continue to be uneven geographically. Looking forward to 2030, the same 48 megacities and superstar hubs that generated 35 percent of the EU’s net job growth in the past decade could account for roughly half of it in the next, based on estimates made before the pandemic.</p>
          <p className="fow-font-text fow-font-size-md">The outlook is tougher for many shrinking regions. The post-2008 recovery largely passed them by, and now many could be facing another decade of low potential job growth. Stable economies should continue to generate modest job growth once they recover from the pandemic, just as they did in the past decade. Around 40 percent of Europe’s population lives in regions that could have fewer jobs in 2030 than they do today in absolute terms. However, aging and emigration are shrinking the workforce in these regions, which lessens the likelihood of high unemployment.</p>
        </div>
        <div className="fow-col fow-col-1-2 fow-md-col-1">
          <h2 className="fow-font-text fow-font-size-lg fow-carousel-item-block-subtitle">Disparities between clusters are widening, with just 48 dynamic growth hubs generating more than one-third of Europe’s job growth since 2007.</h2>
          <SVGImage src={`${baseUrl}home/increasing-geographic-concentration-today.svg`} />
          <Source text="Source: Eurostat, Oxford Economics; McKinsey Global Institute analysis." />
        </div>
      </CarouselItem>
    );
  }
}

const mapStateToProps = state => {
  return {
    baseUrl: state.settings.baseUrl
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(GeoConcentrationToday);
